export function formatPhoneNumber(phoneNumber: string): string {
  if (!phoneNumber || phoneNumber === '-') {
    return phoneNumber;
  }

  // Strip everything from the phone number except digits
  const strippedNumber = phoneNumber.replace(/\D/g, '');

  // Format based on the length of the stripped number
  const length = strippedNumber.length;
  if (length === 10) {
    return `(${strippedNumber.slice(0, 3)}) ${strippedNumber.slice(3, 6)}-${strippedNumber.slice(6)}`;
  } else if (length === 11) {
    return `+${strippedNumber.slice(0, 1)} (${strippedNumber.slice(1, 4)}) ${strippedNumber.slice(4, 7)}-${strippedNumber.slice(7)}`;
  } else if (length === 12) {
    return `+${strippedNumber.slice(0, 2)} (${strippedNumber.slice(2, 5)}) ${strippedNumber.slice(5, 8)}-${strippedNumber.slice(8)}`;
  } else if (length > 13) {
    return phoneNumber;
  }

  // If none of the above conditions are met, return the stripped number as is
  return strippedNumber;
}
